import { useMediaQuery, Theme } from '@mui/material';

export const useResponsiveCarousel = () => {
  const lessMd = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const lessLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const slidesPerView = lessLg ? (lessMd ? 1 : 2) : 3;
  const gap = lessMd ? 0 : 40;

  return {
    lessMd,
    lessLg,
    slidesPerView,
    gap,
  };
};
